import {ImageWithFormats} from '@web-landing/strapi/types';

type Props = {
  imageData: ImageWithFormats;
} & Omit<
  React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  >,
  'src' | 'srcSet'
>;
export default function ProxyImage({imageData, ...rest}: Props) {
  return (
    <img
      srcSet={imageData.url}
      alt={imageData.alternativeText ?? imageData.name}
      loading="lazy"
      {...rest}
    />
  );
}
